import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchAdminUserStats } from '../../actions/adminActions'
import { Stat } from './Stats'

export const UserStats = () => {
  const dispatch = useDispatch()
  const userStats = useSelector(store => store.admin.userStats)

  useEffect(() => {
    dispatch(fetchAdminUserStats())
  }, [])

  const stats = useMemo(
    () => [
      {
        title: 'Active Users',
        value: userStats?.activeUsers,
        value2: userStats?.allUsers
      },
      {
        title: 'Premium Users',
        value: userStats?.allPremiumUsers,
        value2: userStats?.allUsers
      },
      {
        title: 'Premium Active Users',
        value: userStats?.activePremiumUsers,
        value2: userStats?.activeUsers
      }
    ],
    [userStats]
  )

  return stats.map(stat => <Stat stat={stat} />)
}

export default UserStats
